/** Helpers for Automation Knowledge UI (MVP 1-B Slice 2C-A). */

export const MANIFEST_PAGE_SIZE = 50;
export const JOBS_LIST_LIMIT = 10;

export const FORBIDDEN_KNOWLEDGE_UI_FIELDS = [
  'metadata_json',
  'token',
  'token_encrypted',
  'Authorization',
  'file_body',
  'raw_content',
  'blob_content',
];

export const QUEUED_REFRESH_MESSAGE =
  'Repository metadata sync queued. It will run when the Automation Knowledge refresh worker is enabled.';

export const ACTIVE_SYNC_JOB_MESSAGE =
  'A repository metadata sync is already queued or running for this repository.';

export const ACCESS_DENIED_MESSAGE =
  'You do not have permission to manage Automation Knowledge for this project.';

export function shortSha(value, length = 7) {
  if (!value || typeof value !== 'string') {
    return '—';
  }
  return value.length <= length ? value : value.slice(0, length);
}

export function formatKnowledgeDateTime(value) {
  if (!value) {
    return '—';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString();
}

export function formatRepoDisplay(repoConfig) {
  if (!repoConfig) {
    return 'Repository not configured';
  }
  if (repoConfig.repo_owner && repoConfig.repo_name) {
    return `${repoConfig.repo_owner}/${repoConfig.repo_name}`;
  }
  return repoConfig.repo_url || 'Repository not configured';
}

export function isRepoConfigured(repoConfig) {
  return Boolean(repoConfig?.repo_config_id);
}

export function isRepoReadyForSync(repoConfig) {
  if (!isRepoConfigured(repoConfig)) {
    return false;
  }
  if (!repoConfig.enabled) {
    return false;
  }
  if (repoConfig.verification_required && !repoConfig.verified) {
    return false;
  }
  return true;
}

export function hasActiveRefreshJob(jobs = []) {
  return jobs.some((job) => job.status === 'queued' || job.status === 'running');
}

export function resolveScanKind(latestSnapshot) {
  return latestSnapshot ? 'delta' : 'full';
}

export function resolveSyncButtonLabel(latestSnapshot) {
  return latestSnapshot ? 'Sync latest repository changes' : 'Sync automation repository';
}

export function snapshotMetadataValue(snapshot, key) {
  const metadata = snapshot?.metadata_json;
  if (!metadata || typeof metadata !== 'object') {
    return null;
  }
  return metadata[key] ?? null;
}

export function containsForbiddenKnowledgeFields(text) {
  if (!text) {
    return false;
  }
  const lower = String(text).toLowerCase();
  return FORBIDDEN_KNOWLEDGE_UI_FIELDS.some((field) => lower.includes(field.toLowerCase()));
}
